import { ValidationResult } from './validateSchema';

/**
 * Combines multiple validation results into a single result.
 *
 * @param results - An array of validation results to combine.
 * @returns A single validation result containing the combined validity and messages.
 */
export const combineValidationResults = (
  ...results: ValidationResult[]
): ValidationResult => {
  const allMessages = results.flatMap((r) => r.messages);
  return {
    valid: results.every((r) => r.valid),
    messages: allMessages,
  };
};
